import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

export const themeConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: '#f0eeff' },
          100: { value: '#d9d4ff' },
          200: { value: '#b8b0ff' },
          300: { value: '#9a8eff' },
          400: { value: '#8a7cff' },
          focusRing: { value: '{colors.brand.500}' },
          500: { value: '#7A6BFF' },
          DEFAULT: { value: '#7A6BFF' },
          600: { value: '#6555e0' },
          700: { value: '#5043c2' },
          800: { value: '#3d33a3' },
          900: { value: '#2a2385' },
        },
        contrast: {
          500: { value: '#ffe5a8' },
          DEFAULT: { value: '#ffe5a8' },
        },
        accent: {
          50: { value: '#fff0f5' },
          100: { value: '#ffd6e7' },
          200: { value: '#ffadd2' },
          300: { value: '#ff85b8' },
          400: { value: '#ff5ca3' },
          500: { value: '#ff3d8f' },
          DEFAULT: { value: '#ff3d8f' },
        },
        ocean: {
          50: { value: '#e6f7ff' },
          100: { value: '#b3e5fc' },
          200: { value: '#81d4fa' },
          300: { value: '#4fc3f7' },
          400: { value: '#29b6f6' },
          500: { value: '#03a9f4' },
          DEFAULT: { value: '#03a9f4' },
        },
        surface: {
          50: { value: '#fafbff' },
          100: { value: '#f5f6ff' },
          200: { value: '#eef0ff' },
        },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          focusRing: { value: '{colors.brand.500}' },
          solid: {
            value: '{colors.brand.500}',
          },
          outline: {
            value: '{colors.white.500}',
          },
        },
      },
    },
  },
});

export const theme = createSystem(defaultConfig, themeConfig);
